import httpClient from "Api/httpClient";

const END_POINT = "/hold_tags";

const getNonconformanceHoldTags = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getNonconformanceHoldTag = (hold_tag_id) => {
    if (!hold_tag_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + hold_tag_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printNonconformanceHoldTag = (hold_tag_id) => {
    if (!hold_tag_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + hold_tag_id + "/print_tag";
    return httpClient.get(SINGLE_END_POINT);
};

const createNonconformanceHoldTags = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateNonconformanceHoldTags = (payload, hold_tag_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + hold_tag_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteNonconformanceHoldTags = (hold_tag_id) => {
    const DELETE_END_POINT = END_POINT + "/" + hold_tag_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export {
    getNonconformanceHoldTags,
    getNonconformanceHoldTag,
    printNonconformanceHoldTag,
    createNonconformanceHoldTags,
    updateNonconformanceHoldTags,
    deleteNonconformanceHoldTags,
};
